document.addEventListener(
  'turbo:load',
  () => {
    [].forEach.call(
      document.querySelectorAll(
        '#error_explanation, #flash_notice, #flash_alert, #flash_success',
      ),
      (e) => {
        e.addEventListener('click', () => {
          e.style.display = 'none';
        });
      },
    );
  },
  false,
);
